// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StakeDetailsHeader_wrapper__2-m9S","title":"StakeDetailsHeader_title__25cc9","center":"StakeDetailsHeader_center__3V1dH"};